module.exports = __webpack_public_path__ + "f3e846d368912a3de664dd7fb9165be3.MP3";